/* sugar:assets/email-input.js@2.3.2 */
/*
 * email-input — the Email Input field.
 *
 * Inside an email popup's signup form the form submits itself; this only keeps the inline
 * arrow from submitting twice. On the popup's other pages it hands the address to the popup.
 * Anywhere else (a page, a Popup, an accordion) the field posts its own Shopify customer form
 * and shows the theme's thank-you line when Shopify sends the shopper back.
 *
 * Listeners sit on the document, so a field that arrives after load works the same.
 */
(function () {
  if (window.SugarEmailInput) return;

  function rootOf(el) {
    return el && el.closest('.sugar-email-input[data-email-input]');
  }

  function context(root) {
    if (root.closest('[data-email-popup-form]')) return 'form';
    if (root.closest('.sugar-email-popup')) return 'popup';
    return 'page';
  }

  function valid(input) {
    if (input.value && input.checkValidity()) return true;
    input.reportValidity();
    return false;
  }

  /* The popup's own pages outside its form: the popup posts the address. */
  function popupSubmit(root) {
    const input = root.querySelector('[data-input-field]');
    const button = root.querySelector('[data-inline-submit]');
    if (!input || !valid(input)) return;
    if (button) button.disabled = true;
    if (typeof window.emailPopupSubmit === 'function') {
      window.emailPopupSubmit(input.value.trim());
    } else if (window.emailPopupShowSuccess) {
      window.emailPopupShowSuccess();
    }
  }

  /* Anywhere else: a real form post, so Shopify's spam protection can step in as usual. The form
     is copied out of its template once per field and armed the way Shopify arms a form the
     shopper types in; it only accepts a post from a form it has armed. */
  function nativeForm(root) {
    if (root._eiForm && root._eiForm.isConnected) return root._eiForm;
    const template = root.querySelector(':scope > template[data-email-input-form]');
    if (!template) return null;
    root._eiForm = template.content.querySelector('form').cloneNode(true);
    document.body.appendChild(root._eiForm);
    return root._eiForm;
  }

  function arm(form, then) {
    const captcha = window.Shopify && window.Shopify.captcha;
    const armed = form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound');
    if (!captcha || typeof captcha.protect !== 'function' || armed) {
      if (then) then();
      return;
    }
    try {
      captcha.protect(form, then);
    } catch (e) {
      if (then) then();
    }
  }

  function pageSubmit(root) {
    const input = root.querySelector('[data-input-field]');
    const form = nativeForm(root);
    if (!input || !form || !valid(input)) return;
    if (root.dataset.submitting) return;
    root.dataset.submitting = 'true';
    const button = root.querySelector('[data-inline-submit]');
    if (button) button.setAttribute('aria-disabled', 'true');

    form.querySelector('[name="contact[email]"]').value = input.value.trim();
    /* Back to this exact address (an alternate template, a preview), not the page's bare path */
    const returnTo = form.querySelector('[data-email-input-return-to]');
    if (returnTo) {
      const url = new URL(window.location.href);
      url.searchParams.set('customer_posted', 'true');
      returnTo.value = url.pathname + url.search + '#EmailInput-' + root.dataset._sf;
    }
    arm(form, function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });

    /* A challenge the shopper closes leaves them on the page; let them try again */
    setTimeout(function () {
      delete root.dataset.submitting;
      if (button) button.removeAttribute('aria-disabled');
    }, 8000);
  }

  function submit(root) {
    const where = context(root);
    if (where === 'popup') popupSubmit(root);
    else if (where === 'page') pageSubmit(root);
  }

  document.addEventListener('click', function (e) {
    const button = e.target.closest('[data-inline-submit]');
    const root = rootOf(button);
    if (!root) return;

    if (context(root) === 'form') {
      /* Never disable the submitter inside its own click: that cancels the native submit. */
      if (root.dataset.submitting) {
        e.preventDefault();
        return;
      }
      const input = root.querySelector('[data-input-field]');
      if (!input || !input.value || !input.checkValidity()) return;
      root.dataset.submitting = 'true';
      button.setAttribute('aria-disabled', 'true');
      button.style.opacity = '0.7';
      button.style.cursor = 'wait';
      setTimeout(function () {
        if (!document.body.contains(button)) return;
        const popup = button.closest('.sugar-email-popup');
        if (popup && popup.querySelector('[data-page="success"].is-active')) return;
        delete root.dataset.submitting;
        button.removeAttribute('aria-disabled');
        button.style.opacity = '';
        button.style.cursor = '';
      }, 15000);
      return;
    }

    e.preventDefault();
    submit(root);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-input-field]')) return;
    const root = rootOf(e.target);
    if (!root) return;
    const where = context(root);
    /* In the popup's form Enter submits natively; on its other pages only with the arrow shown. */
    if (where === 'form' || (where === 'popup' && !root.querySelector('[data-inline-submit]'))) return;
    e.preventDefault();
    submit(root);
  });

  document.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches('[data-input-field]')) return;
    const root = rootOf(e.target);
    if (root && context(root) === 'page') {
      const form = nativeForm(root);
      if (form) arm(form);
    }
  });

  /* Shopify sends the shopper back with customer_posted=true and the field's form as the #anchor. */
  function showPosted() {
    if (new URLSearchParams(window.location.search).get('customer_posted') !== 'true') return;
    const match = window.location.hash.match(/^#EmailInput-(.+)$/);
    if (!match) return;
    const root = document.querySelector('.sugar-email-input[data-email-input][data-_sf="' + CSS.escape(match[1]) + '"]');
    if (!root) return;
    const message = document.createElement('p');
    message.className = 'sugar-email-input__success';
    message.setAttribute('role', 'status');
    message.textContent = root.dataset.successText || '';
    root.querySelectorAll(':scope > .sugar-email-input__label, :scope > .sugar-email-input__wrapper').forEach(function (el) {
      el.style.display = 'none';
    });
    root.appendChild(message);
    /* The Opt-In Button that sent it has nothing left to do */
    const section = root.closest('.shopify-section');
    for (let node = root.parentElement; node && node !== section; node = node.parentElement) {
      const button = node.querySelector('.sugar-opt-in-button');
      if (button) {
        button.style.display = 'none';
        break;
      }
    }
    root.scrollIntoView({ block: 'center' });
    try {
      const params = new URLSearchParams(window.location.search);
      ['customer_posted', 'form_key', 'form_type'].forEach(function (key) {
        params.delete(key);
      });
      const query = params.toString();
      history.replaceState(history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    } catch (e) {
      /* an address bar that keeps the flag only replays the message on reload */
    }
  }

  window.SugarEmailInput = {
    /* An Opt-In Button outside an email popup submits the nearest field around it. */
    submitNear: function (el) {
      const section = el && el.closest('.shopify-section');
      for (let node = el && el.parentElement; node && node !== section; node = node.parentElement) {
        const root = node.querySelector('.sugar-email-input[data-email-input]');
        if (root) {
          submit(root);
          return true;
        }
      }
      return false;
    },
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showPosted);
  else showPosted();
})();
